// ** Navigation imports
import Dashboard from './Dashboard';
import Item from './Item';
import ModulePages from './ModulePages';
import Setup from './Setup';
import Table from './Table';

// ** Merge & Export
export default [...Dashboard, ...Table, ...ModulePages, ...Setup];
